/* This file helps to interact with server with interceptors */
import axios from "axios";
import { attachFreshToken } from "./token-refresh";
import { BASE_URL } from "./endpoints";

const client = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json"
  }
});

// Single token middleware: renews a near-expiry token before the request goes
// out instead of ejecting the user at a fixed pre-expiry threshold.
client.interceptors.request.use(attachFreshToken);

const noAuthClient = axios.create({
  baseURL: BASE_URL
});

export { client, noAuthClient };
